import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

var ArticleWidgetFormattedText = createReactClass({
  propTypes: {
    index: PropTypes.number,
    text: PropTypes.string,
    uuid: PropTypes.string,
    name: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
  },

  getDefaultProps: function() {
    return {
      index: 0,
      text: '',
      uuid: '',
      name: '',
      title: '',
      changeObject: function() {},
    };
  },

  getWidgetObject: function() {
    return {
      type: 'text',
      text: this.props.data.text,
      name: this.props.name,
      header: this.props.data.header,
      uuid: this.props.data.uuid,
    };
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  componentDidMount: function() {
    var name = 'ckeditor_' + this.props.index;
    var editor = window.CKEDITOR.instances[name];

    var _this = this;

    var ed = window.CKEDITOR.replace(name, {
      filebrowserBrowseUrl: '/admin/media?cs=' + this.props.contentSpace,
      filebrowserImageBrowseUrl: '/admin/media?cs=' + this.props.contentSpace,
    });

    ed.setData(this.props.data.text || '');

    ed.on('change', function(ev) {
      var content = ev.editor.getData();
      _this.onChangeContent(content);
    });
  },

  componentDidUpdate: function() {
    var name = 'ckeditor_' + this.props.index;
    var _this = this;

    var editor = window.CKEDITOR.instances[name];

    if (!editor) {
      var ed = window.CKEDITOR.replace(name);
      ed.setData(this.props.data.text || '');
      ed.on('change', function(ev) {
        var content = ev.editor.getData();
        _this.onChangeContent(content);
      });
    }
  },

  onChangeContent: function(content) {
    var object = this.getWidgetObject();
    object.text = content;
    this.props.changeObject(this.props.index, object);
  },

  onChangeName: function(event) {
    var value = event.target.value;
    var object = this.getWidgetObject();
    object.header = value;
    this.props.changeObject(this.props.index, object);
  },

  render: function() {
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">
          <input
            onChange={this.onChangeName}
            value={this.props.data.header}
            type="text"
            placeholder="Nadpis textového bloku"
            className="form-control"
            name="widget-text"
          />
          <textarea
            placeholder=""
            rows="10"
            cols=""
            className="form-control"
            id={'ckeditor_' + this.props.index}
            name="text"
          />
        </div>
      </div>
    );
  },
});

export default ArticleWidgetFormattedText;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleWidgetFormattedText.jsx